import { getIn, useFormikContext } from "formik";
import { sendFile } from "../../../../../common/services/hold-document";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import { prepareFileForUpload } from "../../../../../common/helpers/file-upload";

type Props = {
  pathToUpload: string;
  name: string;
  className?: string;
  uploadName?: string;
  children?: (props: {
    src: string;
    onNewFile: (file: File) => Promise<void>;
    onRemoveClick: () => void;
  }) => React.ReactNode;
}

export const UploadDocumentFieldFormik: React.FC<Props> = (props: Props) => {
  const { notifySuccess, notifyError } = useToastContext()
  const { values, setFieldValue } = useFormikContext();
  const currentSrc = getIn(values, props.name)

  function sanitizeFileNamePart(value: string) {
    return value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function buildUploadFileName(file: File) {
    const extension = file.name.split(".").pop() || "jpg";
    const sanitizedName = sanitizeFileNamePart(props.uploadName || "");
    const baseName =
      sanitizedName || `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    return `${baseName}.${extension}`;
  }

  async function handleNewFile(file) {
    try {
      const fileToUpload = await prepareFileForUpload(file);
      const prefix = props.pathToUpload;
      const { ok, data, message } = await sendFile({
        prefix,
        file: fileToUpload,
        name: buildUploadFileName(fileToUpload),
      });

      if (!ok) {
        notifyError(message || "não foi possivel salvar o arquivo, tente novamente");
        return;
      }

      const [{ key }] = data;
      setFieldValue(props.name, key);

      notifySuccess("arquivo salvo com sucesso");
    } catch (err) {
      console.log(err)
      notifyError((err as { message: string }).message || 'não foi possivel salvar o arquivo, tente novamente')
    }
  }

  function handleRemoveFile() {
    setFieldValue(props.name, '')
  }

  return (
    <div className={`flex justify-center items-center ${props.className}`}>
      {props.children && typeof props.children === 'function' &&
        props.children({
          src: currentSrc,
          onNewFile: handleNewFile,
          onRemoveClick: handleRemoveFile,
        })}
    </div>
  )
}
